/**
 */
export enum ScreenPin {
  TopLeft = "top-left",
  TopMiddle = "top-middle",
  TopRight = "top-right",
  MiddleRight = "middle-right",
  BottomRight = "bottom-right",
  BottomMiddle = "bottom-middle",
  BottomLeft = "bottom-left",
  MiddleLeft = "middle-left",
  Middle = "middle"
}
